{
    "LockedOut": "Benutzer gesperrt:",
    "PromptTos": "Prompt-Nutzungsbedingungen:",
    "NotifyPasswordChange": "Passwortänderung benachrichtigen:",
    "UpdateInterval": "Berichtsaktualisierungsintervall:",
    "UpdateIntervalCharacter": "s",
    "UpdateIntervalValidation": "Das Berichtsaktualisierungsintervall beträgt maximal 180 Sekunden",
    "MediaPlayer": "Deaktivieren Sie Media Player Plugin-Ins:",
    "DragAndDrop": "Deaktivierte Drag & Drop-Funktionen:",
    "JavascriptOutput": "JavaScript-Audit-Ausgabe:",
    "AutoValue": "[Auto]",
    "SettingsLanguage_ServiceNotification": "Servicebenachrichtigung:",
    "SettingsLanguage_ConcurrentSignins": "Gleichzeitige Anmeldungen zulässig:",
    "SettingsLanguage_AdvancedTitle": "Erweiterte Diagnose",
    "NAME": "SettingsLanguage",
    "SettingsLanguage_AuthNotifications": "Autorisierungs-Benachrichtigung:",
    "SettingsLanguage_NewDeviceNotifications": "Bereitstellungsbenachrichtigungen:",
    "SettingsLanguage_AuthNotifications_Help": "Die Aktivierung von Auth Notifications bedeutet, dass der Administrator eine E-Mail über die erfolgreiche Autorisierung eines MS Teams Telephony Servers erhält",
    "SettingsLanguage_NewDeviceNotifications_Help": "Die Aktivierung von Bereitstellungsbenachrichtigungen bedeutet, dass der Administrator eine E-Mail erhält, wenn ein neues Gerät hinzugefügt oder der Integrationsmodus auf einer MS Teams-Instanz geändert wird."
}